import React from 'react';
import BackgroundText from './BackgroundText';

class Checkout extends React.Component{

	  constructor(props) {
	    super(props);
	    this.state = {
	    	email: '',
	    	name: '',
	    	address: '',
	    	ccv: '',
	    	cc: ''
	    };

	    this.handleInputChange = this.handleInputChange.bind(this);
	  }

	  handleInputChange(event) {
	    const target = event.target;
	    const value =target.value;
	    const name = target.name;
	    this.setState({
	      [name]: value    });
	  }

	handleFormSubmit = (e) => {
		e.preventDefault()
		const regEx = /^5[1-5][0-9]{14}$|^2(?:2(?:2[1-9]|[3-9][0-9])|[3-6][0-9][0-9]|7(?:[01][0-9]|20))[0-9]{12}$/;
		console.log(this.state)
		if(this.state.cc.match(regEx)){
			alert('order placed!');
		}
		else{
			alert('Credit card number is invalid!');
		}
	}

	render(){

		return(

				<div id = 'Checkout'>
					<BackgroundText text = {'React Ecommerce Store'} />
					<div className = 'container'>
						<form onSubmit = {this.handleFormSubmit}>
							<div className = "form-row">
								<div className = "form-group col-md-6">
							    	<label htmlFor="name">Name</label>
							    	<input name = "name" type="text" className ="form-control" id="name" placeholder="John Doe" onChange = {this.handleInputChange} required />
								</div>
								<div className = "form-group col-md-6">
							    	<label htmlFor="email">Email</label>
							    	<input name = "email" type="email" className ="form-control" id="email" placeholder="Email" onChange = {this.handleInputChange} required />
								</div>
							</div>
							<div className = "form-group">
						    	<label htmlFor="address">Address</label>
						    	<input name = "address" type="text" className ="form-control" id="address" placeholder="123 Street" onChange = {this.handleInputChange} required />
							</div>
							<div className = "form-row">
								<div className = "form-group col-md-6">
							    	<label htmlFor="cc">Credit Card Number</label>
							    	<input name = "cc" type="text" className ="form-control" id="cc" placeholder="123456789" onChange = {this.handleInputChange} required />
								</div>
								<div className = "form-group col-md-6">
							    	<label htmlFor="ccv">CCV</label>
							    	<input name = "ccv" type="text" className ="form-control" id="ccv" placeholder="123" onChange = {this.handleInputChange} required />
								</div>
							</div>
							<button type="submit" className="btn btn-primary">Submit</button>
						</form>		
					</div>
				</div>


			)
	}
}

export default Checkout;